import React, { Component } from 'react'
import { Button, Form, Input, Select, DatePicker, TimePicker, message, Modal, InputNumber, Checkbox, Card, Spin, Switch, Icon, Table, Collapse } from 'antd'
import NumberFormat from 'react-number-format'
import {connect} from 'dva'
import {Link} from 'dva/router'
import { all, create, get } from '../../services/restApi'
import moment from 'moment'
import PropTypes from 'prop-types'
import { createPassword } from '../../utils'
const _ = require('underscore')

const { Column } = Table;
const FormItem = Form.Item;
const Option = Select.Option;
const TextArea = Input.TextArea;
const confirm = Modal.confirm
const Panel = Collapse.Panel

class TourNew extends Component {

    constructor (props) {
        super(props);

        this.state = {
            activities: [],
            tours: [],
            hours: []
        }

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {

        // Query Hotel
        let queryHotel = {};
        this.state.currentHotel ? queryHotel.objectId = this.state.currentHotel.objectId : null;

        // Consulta las categorías principales del hotel asignado al gerente o recepcionista
        all('Activity', {
            limit: 1000
        }).then((resp) => {
            this.setState({ activities: resp.results });

            if (this.props.tourId)
                this.getItem();
        })
    }


    /**
    * Obtiene la información del registro
    */
    getItem () {
        this.props.dispatch({type: 'app/showLoadingTable'})
        get('Tour', this.props.tourId, {
            include: 'activity,activity.category,createdBy',
        }).then((resp) => {

            resp.date = moment(new Date(resp.date.iso), 'YYYY/MM/DD');
            if (resp.activity) resp.activity = {key: resp.activity.objectId, label: resp.activity.name};
            if (resp.duration) resp.duration = {key: resp.duration, label: resp.duration};

            // Si el registro devuelve la periodicidad, entonces lo asignamos al formulario de manera manual
            if (resp.repeat && resp.periodicity) {
                setTimeout(function() {
                    resp.periodicity = {key: resp.periodicity, label: resp.periodicity};
                    this.props.form.setFieldsValue({ periodicity: resp.periodicity });
                }.bind(this), 100);
            }

            // Verificamos si el día que se eligió se encuentra entre los días bloqueados
            let days_disabled = _.find(resp.days_disabled, {date: moment(this.props.date).format('DD-MM-YYYY')});
            days_disabled ? resp.active = false : resp.active = true;

            // Realiza el mapeo de las horas para asignar cada valor a los inputs
            this.setState({hours: resp.hours});
            setTimeout(function() {

                resp.hours.map((item, key) => {
                    let data = {};
                    data[item.id + '_pax'] = _.find(resp.hours, {id: item.id}).pax;

                    this.props.form.setFieldsValue(data);
                });
            }.bind(this), 500);

            console.log(resp);

            // Establece el elemento actual
            this.setState({currentItem: resp});
            
            // Establece los datos actuales en el formulario
            this.props.form.setFieldsValue(resp);
            this.props.dispatch({type: 'app/hideLoadingTable'})
        })
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectActivityChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


    /**
    * Acción cuando el input de fecha cambia
    */
    handleSelectDateChange () {
        if (this.props.form.getFieldValue('duration')) {
            setTimeout(function() {
                this.handleSelectDurationChange(this.props.form.getFieldValue('duration'))
            }.bind(this), 500);
        }
    }


    /**
    * Acción cuando el input de duración cambia
    */
    handleSelectDurationChange (value) {
        if (value && value.key) {

            this.setState({hours: []});

            let duration = 1;

            if (value.key === '1 hora')
                duration = 1

            if (value.key === '2 hora')
                duration = 2

            if (value.key === '3 hora')
                duration = 3

            if (value.key === '4 hora')
                duration = 4


            let startDate = moment(this.props.form.getFieldValue('date')).startOf('hour').format(); // Moment
            let endDate = moment(this.props.form.getFieldValue('date')).endOf('day').format(); // Timestamp
            let timestamp = new Date(startDate).getTime();

            let hours = [];

            while (timestamp < new Date(endDate).getTime()) {
                let minHour = moment(startDate).format('H:mm');
                let maxHour = moment(startDate).add(duration, 'hour').format('H:mm')

                hours.push({id: createPassword(), minHour: minHour, maxHour: maxHour});

                startDate = moment(startDate).add(duration, 'hour').format();
                timestamp = new Date(startDate).getTime();
            }

            this.setState({hours: hours});
        }   
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkAmount (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.]/g, '')) === 0) {
            callback('Por favor, ingrese el monto a facturar!');
        } else {
            callback();
        }
    } 


    /**
    * Muestra el modal de los detalles del cliente
    */
    showClientDetails () {
        this.props.dispatch({type: 'app/showLoading'})

        get('Client', this.props.form.getFieldValue('client').key).then((resp) => {

            this.setState({ currentClient: resp });
            this.props.dispatch({type: 'app/hideLoading'})
            this.setState({ showModalClientDetails: true });

        }).catch(e => {
            this.props.dispatch({type: 'app/hideLoading'})
            message.error('Ha ocurrido un error al consultar la información. Intente más tarde')    
        });
    }

    hideModalClientDetails () { this.setState({ showModalClientDetails: false }); }


    /**
    * Registro
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            let data = {};
            data.activity = {__type: 'Pointer', className: 'Activity', objectId: values.activity.key};
            data.date = {__type: 'Date', iso: new Date(values.date).toISOString()};
            data.duration = values.duration.key;
            data.createdBy = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId};
            values.repeat ? data.repeat = true : data.repeat = false;
            data.hours = [];

            if (data.repeat) 
                data.periodicity = values.periodicity.key;

            _.map(this.state.hours, (item) => {
                var pax = this.props.form.getFieldValue(item.id + '_pax');
                pax ? item.pax = pax : item.pax = 0;

                data.hours.push(item);
            });

            if (!this.props.tourId) {
                // CREA

                data.days_disabled = [];
                
                this.props.dispatch({type: 'app/showButtonLoading'})

                create('Tour', data).then(resp => {

                    _.extend(data, resp);
                    data.activity = _.find(this.state.activities, {objectId: data.activity.objectId});
                    data.createdBy = this.props.app.user;

                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    message.success('Se ha creado el registro exitosamente');

                    this.props.dispatch({type: 'tour/createSuccess', payload: data})
                    this.props.form.resetFields();

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                // Verificamos si la fecha que se eligió en el calendario está dentro del array de fechas bloqueadas
                let disabled = _.find(this.state.currentItem.days_disabled, {date: moment(this.props.date).format('DD-MM-YYYY')});

                // Inicializamos el valor del array de días bloqueados
                data.days_disabled = this.state.currentItem.days_disabled;

                if (values.active) {                     
                    // Si existe la fecha en el array entonces se elimina
                    if (disabled) data.days_disabled = _.without(data.days_disabled, disabled);

                } else {
                    // Si no existe la fecha en el array entonces se agrega
                    if (!disabled) data.days_disabled.push({date: moment(this.props.date).format('DD-MM-YYYY')});
                }

                data.objectId = this.props.tourId;
                //data.activity = _.find(this.state.activities, {objectId: data.activity.objectId});
                data.createdBy = this.props.app.user;
                this.props.dispatch({type: 'tour/update', payload: data})
            }
        })
    }


    /**
    * Render del componente
    */
    render () {
        const activity_options = this.state.activities.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div>
                <Form onSubmit={this.handleSubmit.bind(this)}>
                    <Spin spinning={this.props.app.loadingTable}>
                        <div className="row">
                            {this.props.tourId
                                ? <div className="col-md-12">
                                    Disponibilidad {this.props.date ? 'para el ' + moment(this.props.date).format('DD-MM-YYYY') : ''} <FormItem>
                                        {this.props.form.getFieldDecorator('active')(
                                            <Switch checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} checked={this.props.form.getFieldValue('active')} />
                                        )}
                                    </FormItem>
                                </div>
                                : ''
                            }
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <FormItem label="Actividad">
                                    {this.props.form.getFieldDecorator('activity', {
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, elija la actividad'
                                        }]
                                    })(
                                        <Select 
                                            size='large'
                                            mode="combobox"
                                            onChange={this.handleSelectActivityChange.bind(this)}
                                            filterOption={false}
                                            labelInValue={true}
                                            optionLabelProp='label'
                                            placeholder="Elija la actividad"
                                            >
                                            {activity_options}
                                        </Select>
                                    )}
                                </FormItem>
                            </div>

                            <div className="col-md-6">
                                <FormItem label="Fecha y hora inicial" hasFeedback>
                                    {this.props.form.getFieldDecorator('date', {
                                        initialValue: moment(),
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, seleccione la fecha',
                                        }]
                                    })(
                                        <DatePicker 
                                            showTime 
                                            format="DD-MM-YYYY H:mm a" 
                                            onChange={this.handleSelectDateChange.bind(this)}
                                            />
                                    )}
                                </FormItem>
                            </div>
                        </div>

                        {this.props.form.getFieldValue('date')
                            ? <div className="row">
                                <div className="col-md-6">
                                    <FormItem label="Duración" hasFeedback>
                                        {this.props.form.getFieldDecorator('duration', {
                                            rules: [{
                                                required: true,
                                                message: 'Por favor, elija una opción',
                                            }]
                                        })(
                                            <Select 
                                                size='large'
                                                filterOption={false}
                                                labelInValue={true}
                                                optionLabelProp='label'
                                                onChange={this.handleSelectDurationChange.bind(this)}
                                                >
                                                <Option key="1 hora" label="1 hora">1 hora</Option>
                                                <Option key="2 hora" label="2 hora">2 hora</Option>
                                                <Option key="3 hora" label="3 hora">3 hora</Option>
                                                <Option key="4 hora" label="4 hora">4 hora</Option>
                                            </Select>
                                        )}
                                    </FormItem>
                                </div>
                            </div>
                            : ''
                        }

                        <div className="row">
                            <div className="col-md-12">
                                <FormItem label="" style={{margin: 0}}>
                                    {this.props.form.getFieldDecorator('repeat')(
                                        <Checkbox checked={this.props.form.getFieldValue('repeat')}>Repetir periódicamente</Checkbox>
                                    )}
                                </FormItem>
                            </div>

                            {this.props.form.getFieldValue('repeat')
                                ? <div className="col-md-6">
                                    <FormItem label="Periodicidad" hasFeedback>
                                        {this.props.form.getFieldDecorator('periodicity', {
                                            rules: [{
                                                required: true,
                                                message: 'Por favor, elija una opción',
                                            }]
                                        })(
                                            <Select 
                                                size='large'
                                                filterOption={false}
                                                labelInValue={true}
                                                optionLabelProp='label'
                                                >
                                                <Option key="Diariamente" label="Diariamente">Diariamente</Option>
                                                <Option key="Semanalmente" label="Semanalmente">Semanalmente</Option>
                                                <Option key="Mensualmente" label="Mensualmente">Mensualmente</Option>
                                                <Option key="Anualmente" label="Anualmente">Anualmente</Option>
                                            </Select>
                                        )}
                                    </FormItem>
                                </div>
                                : ''
                            }
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <Collapse defaultActiveKey={['1']} className="marginBottom20">
                                    <Panel header="Horarios" key="1">
                                        <Table 
                                            dataSource={this.state.hours} 
                                            rowKey="id" 
                                            size="small" 
                                            pagination={false}>

                                            <Column title="Nombre" key="name" render={(item) => (
                                                <span>{item.minHour} hrs - {item.maxHour} hrs</span>
                                            )}/>

                                            <Column title="Cupo" key="days" width={70} render={(item) => (
                                                <FormItem style={{marginBottom: 0}} className={this.props.form.getFieldValue(item.id + '_pax') === 0 ? 'input-mask-disabled' : ''}>
                                                    {this.props.form.getFieldDecorator(item.id + '_pax', {
                                                        initialValue: 0
                                                    })(
                                                        <InputNumber min={0} className="ant-input ant-input-lg" />
                                                    )}
                                                </FormItem>
                                            )}/>
                                        </Table>  
                                    </Panel>
                                </Collapse>
                            </div>
                        </div>

                        <div className="row text-center paddingTop20">
                            <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                Guardar
                            </Button>
                        </div>
                    </Spin>
                </Form>
            </div>
        )
    }
}

TourNew.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({tour, app}) => ({tour, app}))(Form.create()(TourNew))



// WEBPACK FOOTER //
// ./src/components/tours/tourNew.js